import { TMasterStandardIndustryGroup } from "@/api/entities/master-standard-industry-group.entity";
import { StandardIndustryClassificationTable } from "@/features/master-data/components/StandardIndustry/StandardIndustryClassificationTable";
import { StandardIndustryGroupList } from "@/features/master-data/components/StandardIndustry/StandardIndustryGroupList";
import { useState } from "react";

export const MasterDataStandardIndustry = () => {
  const [selectedGroup, setSelectedGroup] = useState<TMasterStandardIndustryGroup>();

  if (selectedGroup) {
    return <StandardIndustryClassificationTable group={selectedGroup} onBack={() => setSelectedGroup(undefined)} />;
  }

  return <StandardIndustryGroupList onSelectGroup={setSelectedGroup} />;
};
